import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { getCollections } from "../api";
import { useToast } from "./useToast";

interface CollectionsContextData {
  collections?: any[];
  setCollections: Dispatch<SetStateAction<any[] | undefined>>
}

const CollectionsContext = createContext({} as CollectionsContextData);

export function CollectionsProvider(props: PropsWithChildren) {
  const { children } = props;

  const [collections, setCollections] = useState<any[]>();
  const { toast } = useToast()

  const fetchCollections = async () => {
    try {
      const collectionsResponse = await getCollections();
      setCollections(collectionsResponse);
    } catch (error) {
      toast({
        message: "Erro ao carregar avaliações",
        type: "error",
      });
    }
  };

  useEffect(() => {
    fetchCollections();
  }, []);

  return (
    <CollectionsContext.Provider value={{ collections, setCollections }}>
      {children}
    </CollectionsContext.Provider>
  );
}

export function useCollections() {
  const context = useContext(CollectionsContext);
  return context;
}
